import React, { useState } from 'react';
import axios from 'axios'
import { useEffect, useRef } from 'react';
import {Input, Dropdown, Form, Button, Modal, Label} from 'semantic-ui-react'
import { Fragment } from 'react';
import { Message, Confirm} from 'semantic-ui-react';

// import './LabLayout.css'; CAUTION! see notes below
// importing css causes issues when building the project at aws code build
// see app/assets/stylesheets/lab.css
// used at app/views/layouts/lab_layout.html.haml

import Thumbs from './Thumbs'
import SideTabs from './SideTabs'
import ReactNotification, { store } from 'react-notifications-component';
// import 'react-notifications-component/dist/theme.css'
// import 'animate.css/animate.min.css';
import PageVisibility from 'react-page-visibility';
import Zoom from './Zoom'
import UserCard from './Card'
import CircuitName from './CircuitName'
import ClassRooms from './ClassRooms'
import ShowOff from './ShowOff'

import {
  Checkbox,
  Grid,
  Header,
  Icon,
  Image,
  Menu,
  Segment,
  Sidebar,
} from 'semantic-ui-react'
import Share from "./Share";

  function LabLayout(props){
      return (
        <div className="app-container">
        <ReactNotification />
        <Layout {...props}/>
        </div>
      )
  }


function Layout(props)
{
    let limitation_notification_id= 0;
    let last_visiblity_change= null;
    let background = '#000000';
    let forecolor = '#ffffff';
    const [time_at_vsible, setTime_at_vsible] = useState(0);
    const [is_labLoaded, setLabLoaded] = useState(false);
    const [is_public, setPublic] = useState(false);
    const [isSaveOpened, setSaveOpened] = useState(false);
    const [isSaveSubmited, setSaveSubmited] = useState(false);

    const [isSaving, setIsSaving] = useState(false);
    const [isAnswering, setIsAnswering] = useState(false);
    const [isEditingAssignment, setIsEditingAssignment] = useState(false);

    const [isRetryOpened, setRetryOpened] = useState(false);
    const [customErrorOpened, setCustomError] = useState(false);

    const [mark, setMark] = useState(0);
    const [markCaption, setMarkCaption] = useState("");


    const [title, setTitle] = useState("");
    const [titleBefore, setTitleBefore] = useState("");
    const [experiment_id, setExperiment_id] = useState("");

    const [description, setDescription] = useState("");

    const [submitAnswerDialogShown, showSubmitedAnswerDialog] = useState(false);



    const [visible, setVisible] = React.useState(false)
    const [user, setUser] = React.useState(null)
    const [submittedAt, setSubmittedAt] = React.useState(null)
    const [submission, setSubmision] = React.useState(null)
    const [isTeacher, setIsTeacher] = React.useState(null)
    const [circuit, setCircuit] = React.useState({})

    const [userMenu, setUserMenu] = React.useState(null)

    const [triedToSave, setTriedToSave] = React.useState(0)

    const [useNGSpice, setUseNGSpice] = React.useState(false)
    const [NGSpiceNetList, setNGSpiceNetList] = React.useState("")


    const [descriptionShown, setDescriptionShown] = React.useState(false)

    const force_show_thumbs = true;
    const isResubmit = () => {
        return props.submission != null && props.submission.submitted_at != null && props.submission.assignment.settings.resubmit_allowed
    }
    const instance = (fun, arg=null) =>{
      // setUseNGSpice true, false
      // setNGSpiceNetList string
      if (fun == "setEditingAssignment"){
          setIsEditingAssignment(arg);
          arg ? $("react-lab-holder").show() : $("react-lab-holder").hide();
      }
      if (fun == "clearDescription"){
          setDescription("");
      }
      if (fun == "saveAssignment"){
          save(arg[0], arg[1])
      }

      if (fun == "setUseNGSpice"){

          if (arg && props.is_mobile == false) setVisible(true);
          setUseNGSpice(arg);
      }
      if (fun == "setNGSpiceNetList")setNGSpiceNetList(arg);
      if (fun == "show_lab_alert"){
        store.addNotification({
          content: (
              <Message icon>
                  <Icon  className='warning alternate' />
                  <Message.Content>
                  <Message.Header>{arg.title}</Message.Header>
                  {arg.text}
                  </Message.Content>
              </Message>
            ),
          insert: "top",
          container: "top-center",
          animationIn: ["animate__animated animate__zoomIn"],
          animationOut: ["animate__animated animate__zoomOut"],
          dismiss: {
            duration: 1000 * arg.seconds,
            showIcon: true,
          }
        });
      }
      if (fun == "show_limitation"){
        if (limitation_notification_id!= 0)
        store.removeNotification(limitation_notification_id);

        limitation_notification_id = store.addNotification({
          content: (
              <Message icon
              onDismiss={()=>{
                if (limitation_notification_id!= 0)
                store.removeNotification(limitation_notification_id);}}
              >

                  <Icon  name='unlock alternate' />
                  <Message.Content>
                  <Message.Header>{l.demo_mode}</Message.Header>
                  <p>{l.limitation_message}</p>
                  <p>{l.limitation_message2}</p>
                  <Button color='green' onClick={()=>window.open("/pricing-table",'_blank')}
                  style={{width: 120, marginLeft: 5, paddingLeft: 5, paddingRight: 5}} size='tiny'>{l.limitation_message3}</Button>
                  {l.limitation_message4}
                  </Message.Content>
              </Message>
            ),
          insert: "top",
          container: "top-center",
          animationIn: ["animate__animated animate__zoomIn"], // `animate.css v4` classes
          animationOut: ["animate__animated animate__zoomOut"], // `animate.css v4` classes
          dismiss: {
            duration: 1000 * 45,
            showIcon: true,
            pauseOnHover: true,
          }
        });
      }
    }

    function now(){
      return (new Date()).getTime()
    }

    function validCircuitName(aTitle){
      return aTitle && aTitle.length > 3 && aTitle.length < 256
    }
    function usePrevious(value) {
      const ref = useRef();
      useEffect(() => {
        ref.current = value;
      });
      return ref.current;
    }

    const wasSaveOpened = usePrevious(isSaveOpened)
    if (wasSaveOpened && !isSaveOpened){
      window.disable_haxe_events = false;
    }
    if (wasSaveOpened === false && isSaveOpened){
      window.disable_haxe_events = true;
    }
    function userMenuChange(e, data){

        if (data.value == "logout")
            document.getElementById("logout").submit();
        else
        window.location = data.value;
    }
    function onZoomMenuChange(e, data){
      window.thumbs.lab("newZoom",data.value);
    }

    //called when user click Yes on submit answer dialog that appears after auto-save, ANSWER btn ->SAVE btn ->DIALOG->YES btn
    function submitAnswer(aIsRetry = false) {
        showSubmitedAnswerDialog(false)
        //1. Save the currect experiment
        save(null, ()=>{
            // submit the answer now
                //save and feedback
                setIsAnswering(true)
                setIsSaving(true)
                setSaveOpened(false)
                setRetryOpened(false)
                let saving_notification_id = store.addNotification({
                    content: (
                        <Message icon color="yellow">
                            <Icon name='circle notched' loading/>
                            <Message.Content>
                                <Message.Header>{l.submiting_answer + '...'}</Message.Header>
                            </Message.Content>
                        </Message>
                    ),
                    insert: "right",
                    container: "top-right",
                    animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                    animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                    dismiss: {
                        duration: 1000 * 60 * 60 * 24
                    }
                });
                const payload = {submission_id: submission.id}
                axios.post("/api/submit-answer", payload)
                    .then(response => {
                            //hide saving progress
                            store.removeNotification(saving_notification_id);
                            setIsSaving(false)
                            setIsAnswering(false)
                            setSubmittedAt(response.data.submitted_at)
                            // Show success notification
                            store.addNotification({
                                content: (
                                    <Message icon positive>
                                        <Icon name='check'/>
                                        <Message.Content>
                                            <Message.Header>{l.submit_successfully}</Message.Header>
                                            {l.your_answer_has_been_saved}
                                        </Message.Content>
                                    </Message>
                                ),
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                                animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                                dismiss: {
                                    showIcon: true,
                                    duration: 0
                                }
                            });
                        }
                    )
                    .catch(error => {
                        store.addNotification({
                            content: (
                                <Message icon color="red">
                                    <Icon name='warning' />
                                    <Message.Content>
                                        <Message.Header>{l.error_submitting_answer}</Message.Header>
                                    </Message.Content>
                                </Message>
                            ),
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                            animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                            dismiss: {
                                duration: 1000 * 5
                            }
                        });
                        store.removeNotification(saving_notification_id)

                        if(error.response.data.status == 900){
                            setCustomError(true);
                            setIsSaving(false);
                            setIsAnswering(false);
                        } else setRetryOpened(true)


                    })
        }//save circuit feedback
        , aIsRetry)//save call
    }
    function onSave(saveAs){
      if (user){
        setTriedToSave(0)
        window.save_as = saveAs;
        window.thumbs.sync();
        setSaveSubmited(false);
        setTitleBefore(title);
        setSaveOpened(true);
      }else{
        let offline_circuit = window.thumbs.lab_state()
        localStorage.setItem('offlineCircuit', JSON.stringify(offline_circuit));
        localStorage.setItem('triedToSave', true);
        setTriedToSave(1)
      }
    }


    function saveMark(){
        setMarkCaption("Saving...")
        setIsSaving(true)
        const payload = {submission_id: submission.id, mark}

        axios.post("/api/classroom/store-mark", payload)
            .then(response => {
                    //hide saving progress
                setMarkCaption("Saved!")
                setIsSaving(false)
                    {
                        store.addNotification({
                            content: (
                                <Message icon positive>
                                    <Icon name='check'/>
                                    <Message.Content>
                                        <Message.Header>{l.saved_succesfully}</Message.Header>
                                        {l.mark_saved_successfully}
                                    </Message.Content>
                                </Message>
                            ),
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                            animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                            dismiss: {
                                duration: 3000
                            }
                        });
                    }
                }
            )
            .catch(error => {
                setMarkCaption("Retry saving")
                setIsSaving(false)
                store.addNotification({
                    content: (
                        <Message icon color="red">
                            <Icon name='warning' />
                            <Message.Content>
                                <Message.Header>{l.error_saving_mark}</Message.Header>
                            </Message.Content>
                        </Message>
                    ),
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                    animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                    dismiss: {
                        duration: 1000 * 5
                    }
                });
                store.removeNotification(saving_notification_id)
            })
    }
    function save(assignment_id = null, success_callback = null, aCallSuccessDirectly = false){
        if (aCallSuccessDirectly) {
            success_callback();
        }
        else
        {
        const isAssignmentCall = assignment_id != null;

        if (!isAssignmentCall && !submission && !validCircuitName(title))
        {
          setSaveSubmited(true)
          return false
        }
        setIsAnswering(false)
        setIsSaving(true)
        setSaveOpened(false)
        setRetryOpened(false)
        let circuits = [...window.thumbs.state.slides]
        circuits = circuits.map((slide, index) => ({circuit: slide.data, text: slide.text}))
        let saving_notification_id = null;
        if (!isAssignmentCall) {
            saving_notification_id = store.addNotification({
                content: (
                    <Message icon color="yellow">
                        <Icon name='circle notched' loading/>
                        <Message.Content>
                            <Message.Header>{l.saving_circuit + '...'}</Message.Header>
                        </Message.Content>
                    </Message>
                ),
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                dismiss: {
                    duration: 1000 * 60 * 60 * 24
                }
            });
        }

        const thumbnail_base64_data = window.thumbs.state.slides[0].base64_shapshot
        //TODO handle this at API backend
        const payload = {assignment_id: assignment_id, experiment_id, save_as: window.save_as, circuits, public: is_public, title: isAssignmentCall ? "Assignment with id:" + assignment_id.toString() : title, thumbnail_base64_data}

        axios.post("/api/store", payload)
            .then(response => {
                //hide saving progress
                if (!isAssignmentCall) store.removeNotification(saving_notification_id);
                setIsSaving(false)
                setIsAnswering(false)
                setExperiment_id(response.data.experiment_id)
                setCircuit({...circuit, share_url: response.data.share_url, lab_title: response.data.lab_title})
                // Show success notification
                //if (!isAssignmentCall)
                {
                    store.addNotification({
                        content: (
                            <Message icon positive>
                                <Icon name='check'/>
                                <Message.Content>
                                    <Message.Header>{l.saved_succesfully}</Message.Header>
                                    {l.your_circuit_has_been_saved}
                                </Message.Content>
                            </Message>
                        ),
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                        animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                        dismiss: {
                            duration: 3000
                        }
                    });
                }
                if (success_callback!= null)
                    success_callback();

              }
            )
            .catch(error => {
              store.addNotification({
                content: (
                    <Message icon color="red">
                        <Icon name='warning' />
                        <Message.Content>
                        <Message.Header>{l.error_saving_circuit}</Message.Header>
                        </Message.Content>
                    </Message>
                  ),
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
                animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
                dismiss: {
                  duration: 1000 * 5
                }
              });
                store.removeNotification(saving_notification_id)

                if(error.response.data.status == 900){
                  setCustomError(true);
                  setIsSaving(false);
                } else setRetryOpened(true)


        })
    }
    };

    const trigger = (avatar, name) => (
        <span>
            <Image src={avatar} avatar />
            {/* <span>{name}</span> */}
        </span>
      )


      React.useEffect(() => {
        // Initialize here:
        setSubmision(props.submission)
        setIsTeacher(props.isTeacher)
        setCircuit(props.circuit)
        setMarkCaption(l.set_mark)
          if (props.submission) {
              setMark(props.submission.mark == null ? 0 : props.submission.mark)
              setSubmittedAt(props.submission.submitted_at)
          }
        window.lab_props= props
        window.view_only_mode = "false";
        if (window.lab_props.submission != null){
            window.add_new_components_allowed = props.submission.assignment.settings.add_new_components_allowed ? 'true' : 'false'
            window.property_inspector_hidden= props.submission.assignment.settings.property_inspector_hidden ? 'true' : 'false';
        }
              setTimeout(()=>{
          window.scrollTo(0,0);
        }, 100);


        window.labLayout = instance;
        $('textarea#description').focus(function() {
          window.disable_haxe_events = true;
        });
        $('textarea#description').on('blur', function(e) {
          window.disable_haxe_events = false;
          window.thumbs.sync();
      });




        window.disable_haxe_events = false;
        setLabLoaded(false)
        setUser(props.user)

        setUserMenu(props.userMenu)
        setExperiment_id(props.experiment_id)

        setTitle(props.title)
        setPublic(props.is_public)
        setTriedToSave(0)
        window.embedLab();

        }, [])
    function user_call_response(response){
      setUser(response.data.user)
      setUserMenu(response.data.userMenu)
      com.clientside.main.Html5Bootstrap.setSubscription(response.data.session.is_subscription_active );
      com.clientside.main.Html5Bootstrap.setSignedIn(response.data.session.is_user_signed_in );
      com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", response.data.session.within_trial_period);
    }
    function handleVisibilityChange (isVisible){
      if (last_visiblity_change == isVisible)return;
      last_visiblity_change =  isVisible;
      if (isVisible && !user) {
        axios.post("/api/current-user.json", {})
            .then(response => {
              user_call_response(response);
                // enhancement: show save dialog now incase he has tried to save when he was not signed in yet
              }
            )
            .catch(error => {
              com.clientside.main.Html5Bootstrap.setSubscription(false);
              com.clientside.main.Html5Bootstrap.setSignedIn(false);
              com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", false);
          })
      }
      if (isVisible && user) {
        axios.post("/api/current-user.json", {})
        .then(response => {
            if (response.data.user.id != user.id)
            {
                window.location = domain_url
            }else{
                user_call_response(response);
            }
          }
        )
        .catch(error => {
          if (error.response.status == 401){
            setSubmision(null)
            setUser(null)
            setUserMenu(null)
            com.clientside.main.Html5Bootstrap.setSubscription(false);
            com.clientside.main.Html5Bootstrap.setSignedIn(false);
            com.clientside.main.Html5Bootstrap.jsCall("within_trial_period", false);
          }
      })
      }
    }
    return(
        //   action_name == 'lab' && ||
        <PageVisibility onChange={handleVisibilityChange}>
        <>
        {/* // TOP MENU */!isEditingAssignment && <>
        <Grid stackable={true} verticalAlign='middle' style={{minHeight: 70, paddingTop: 5, backgroundColor: background}}>

        <Grid.Row  columns={4} style={{paddingTop: 10, paddingBottom: 2}}>

          {/* LOGO */
          <Grid.Column key="logo" width={3} className="middle aligned"  style={{bottom: 0,paddingBottom: 0, minWidth: 200, maxHeight: 38,maxWidth: 200}}>
          <a href={props.home_path}>
          <Image src={props.logo_path} style={{width: 200, marginLeft: 6}} />
          </a>
          </Grid.Column>
          /*end of logo*/ }

      {/* Circuit Name */}
      {
            <>
            <Grid.Column width={5} className="middle aligned"  style={{bottom: 0,paddingBottom: 0}} >
                {/* show for them */}

                { (circuit || title || action_name === 'lab') &&
                <>
                <CircuitName isSaving={isSaving} assignment={props.assignment ? props.assignment : null} circuit={circuit ? circuit : null} title={title} is_public={is_public}/>
                    {submission != null && submittedAt && <p style={{color:"white", marginTop: "revert", fontSize: 11}}>Answered at: {submittedAt}</p>}
                </>
                }
            </Grid.Column>
            </>
        }
      {/* CREATOR CARD */}
      {props.creator && (props.user == null || props.creator.id != props.user.id) &&
        <Grid.Column key="social" width={3} className="middle aligned"  style={{bottom: 0,paddingBottom: 0}}>
            <UserCard creator={props.creator}/>
        </Grid.Column>
      }

      {/* SAVE BUTTONS */}
      {((action_name=='lab' ||( props.user && props.creator && props.user.id == props.creator.id) )) && (false || is_labLoaded) && !isSaving &&
      <Grid.Column key="saveButtons" width={5} className="middle aligned"  style={{bottom: 0,paddingBottom: 0}}>
          <>
          <Button color='orange' onClick={()=>window.open("/lab",'_blank')}
          size='mini'>{l.new}</Button>
          <Button color='green'
          onClick={()=>{onSave(false);}} size='mini'>{l.save}</Button>
          {title!= undefined &&
            <Button color='green'
            onClick={()=>{onSave(true);}}
            size='mini'>{l.save_as}</Button>
          }
          <Checkbox style={{color: forecolor}} onChange={(e, data)=>setPublic(data.checked)} fitted label={l.public} checked={is_public}/>
              { user && user.class_rooms.length > 0 &&
          <ClassRooms selected_class_room_id={user.selected_class_room_id} class_rooms={user.class_rooms} />
          }
          </>
        </Grid.Column>
        }

             {/*ASSIGNMENT BUTTONS*/}
            {(is_labLoaded && action_name=='assignment' && user != null && !props.isTeacher && (submittedAt === null || props.submission.assignment.settings.resubmit_allowed) && props.user && props.creator && submission && submission.user_id == props.user.id) && !isSaving &&
            <Grid.Column key="saveButtons" width={2} className="middle aligned"  style={{bottom: 0,paddingBottom: 0}}>
                <>
                    <Button color='green'
                            onClick={()=>{save();}} size='mini'>{l.save}</Button>
                    {title!= undefined &&
                    <Button color='green'
                            onClick={()=>{showSubmitedAnswerDialog(true)}}
                            size='mini'>{props.submission.submitted_at == null ? l.submit_answer : (props.submission.assignment.settings.resubmit_allowed ? l.resubmit_answer : l.submit_answer)}</Button>
                    }
                </>
            </Grid.Column>
            }

            {submission != null && submittedAt && props.isTeacher &&
            <Grid.Column key="markButton" width={1} className="middle aligned"  style={{bottom: 0,paddingBottom: 0}}>

                    <Input
                        disabled={isSaving}
                        onKeyPress={(event) => {
                            if(event.key == "Enter"){

                                setTimeout(()=>{
                                    saveMark()
                                }, 5)

                            }else {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }
                        }}
                        style={{width:45}}
                        size='mini'
                        action={{
                            color: 'orange',
                            labelPosition: 'left',
                            icon: 'pencil',
                            content: markCaption,
                            onClick: ()=>saveMark()
                        }}
                        actionPosition='left'
                        placeholder=''
                        value={mark}
                        defaultValue='0'
                        onChange={(e, data) => {
                            let v = data.value;
                            if (v > 100) v = 100;
                            setMark(v);
                            setMarkCaption(l.save_mark);
                            }
                        }
                    />

            </Grid.Column>
            }

            <Grid.Column floated='right' key="login" width={3} style={{paddingLeft: 0, minWidth: 200}}>
           <div style={{minWidth: 200}}>
            <div style={{display: 'inline-block', marginRight: 0}}>
            <Zoom zoomMenuChange={onZoomMenuChange}/>

              <Checkbox
                  style={{color: 'white', display: 'inline-block'}}
                  checked={visible}
                  label={l.notes}
                  onChange={(e, data) => {setTime_at_vsible(now());
                    setTimeout(()=>{
                      setVisible(data.checked);
                    }, 1)
                    }}
                />
            </div>

            {/*   User menu, sign in, create account..*/}
           { action_name != "iframe" &&
            <div style={{display: 'inline-block', marginRight: 5}}>
            {!user &&
              <>
              <a className='dcgreen' target="_blank" href="/users/sign_in/">{l.sign_in}</a>
              <span style={{paddingLeft: 5, paddingRight: 5, color: forecolor}}>{l.or}</span>
              <a className='dcorange' target="_blank" href="/users/sign_up">{l.create_an_account}</a>
              </>
            }
            {user && userMenu &&
              <>
              <Dropdown key="profileMenu" onChange= {userMenuChange} pointing='right' trigger={trigger(user.avatar, user.name)} options={userMenu.map((menu, index)=>{
                return (index == 0 || index == userMenu.length -1 ) ? menu : { value: menu.value, key: menu.key + index, text: menu.text, as: ()=>(
                  <div style={{pointerEvents: 'all'}} role="option" aria-checked="false" aria-selected="false" className="item"><span className="text"><a style={{color: '#000000'}} href={menu.value}>{menu.text}</a></span></div>
                ) }
              })} />
              <form method="post" id="logout" action={props.logout_path}>
                  <input type="hidden" name="_method" value="delete" />
                  <input type="hidden" name="authenticity_token" value={props.authenticity_token} />
              </form>
              </>
            }
            </div>}
            </div>

            </Grid.Column>
      </Grid.Row>


            {/* <Grid verticalAlign='middle' style={{backgroundColor: '#394755', height: 58}}>             */}


            </Grid>
            </> /* end of top menu */ }
            {/* // SIDE NOTE */}
      <Grid style={{margin: 0}} columns={1}>

      <Grid.Column style={{padding:0,  marginTop: 14}}>
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            onShow={() => setDescriptionShown(true)}
            onHide={() => {if ((now() - time_at_vsible) < 1000) setDescriptionShown(false)}}
            direction='right'
            animation='overlay'
            icon='labeled'
            inverted
            // onHide={() => setVisible(false)}
            vertical
            visible={visible || isEditingAssignment}
            width='wide'
          >
          {/* SIDE NOTES */}
            <SideTabs setDescription={setDescription} NGSpiceNetList={NGSpiceNetList} isEditingAssignment={isEditingAssignment} ngSpiceSelected={useNGSpice && (description== null || (description!= null && description.length < 10)) && submission == null} useNGSpice={useNGSpice && (submission == null || isTeacher)} description={description}/>
          </Sidebar>
          {/* PUSHED CONTENT: THUMBS AND LAB */}
          <Sidebar.Pusher>
            <Segment style={{padding: 0, paddingTop: 12}} basic>
              <Fragment>
                  {!props.is_mobile && (props.featured_experiments.length > 0 || props.show_ads) &&
                      <ShowOff show_ads={props.show_ads} is_mobile={props.featured_experiments} featured_experiments={props.featured_experiments} />
                  }
                <Grid style={{ padding: 0}}>
                  {/* THUMBS */}
                  {(user || force_show_thumbs) &&
                  <Grid.Column width={1} style={{ paddingRight:2, top:0, backgroundColor: background}}  >
                      <Thumbs forecolor={forecolor} submission={submission} is_mobile={props.is_mobile} user={user} setVisible={setVisible} getDescription={()=>{return description}} setDescription={setDescription} setLabLoaded={setLabLoaded}/>
                  </Grid.Column> }
                  {/* LAB */}
                  <Grid.Column onClick={()=>{
                        if (limitation_notification_id!= 0){ store.removeNotification(limitation_notification_id); }
                        window.thumbs.refresh_current_thumb();
                        }}
                        width={(15 + ((user || force_show_thumbs) ? 0 : 1)) - (descriptionShown ? 0: 0)} style={{height: ((user || force_show_thumbs) ? '100vh' : '100vh'), padding: 0, paddingTop: 0, paddingLeft: ((user || force_show_thumbs) ? 0 : 14), paddingRight: (descriptionShown ? (isEditingAssignment ? 360 : 275) : 0)}}>
                        <div id="lab-div-id" style={{backgroundColor: 'black', height: '100%', marginRight: visible ? 0 : 15}}>
                        </div>
                </Grid.Column>
                </Grid>

                  {/* SUBMIT ANSWER DIALOG */}
                  <Modal dimmer={true} size='small' open={submitAnswerDialogShown}>

                      <Modal.Header>{isResubmit() ? 'Resubmit' : 'Submit'} Your Assignment Now?</Modal.Header>

                      <Modal.Content>
                          <p>Are you sure you want to {isResubmit() ? 'resubmit' : 'submit'} your assignment?</p>
                          {props.submission != null && !props.submission.assignment.settings.resubmit_allowed &&
                            <p>You can not edit your work after submission.</p>
                          }
                      </Modal.Content>
                      <Modal.Actions>
                          <Button negative onClick={() => showSubmitedAnswerDialog(false)}>
                              No
                          </Button>
                          <Button positive onClick={() => submitAnswer()}>
                              Yes
                          </Button>
                      </Modal.Actions>
                  </Modal>

                {/* SAVE DIALOG */}
                <Modal dimmer={true} size='small' open={isSaveOpened}>
                <Header icon='save' content={window.save_as ? l.save_as+":": l.save_circuit} />
                <Form warning={isSaveSubmited && !validCircuitName(title)} id="save_form" error style={{padding: 20}} >
                    <Form.Field>
                      <label>{l.circuit_name}</label>
                      <Form.Input padding={20} autoFocus
                      onKeyPress= {(e)=>{
                        if(e.key === 'Enter'){
                        save()
                      }}}
                      error={validCircuitName(title) ? false: isSaveSubmited ? true : false }
                      onChange={(e, data)=>{
                        setTitle(data.value);
                      }} style={{borderRadius: '10px', width: '100%', height: 28, backgroundColor: 'khaki'}}
                      placeholder={l.circuit_name +'...'} value={title} />
                    </Form.Field>

                    <Message
                      warning
                      header={l.circuit_invalid_name}
                      list={[
                        l.circuit_name_0,
                        l.circuit_name_1
                      ]}
                    />


                  <Modal.Actions style={{textAlign: 'right', paddingTop: 10}}>

                    <Button style={{visibility: 'hidden'}}/>
                    <Button active={false} color='grey' onClick={(e) => {setSaveOpened(false); setTitle(titleBefore);}}>
                      {l.cancel}
                    </Button>
                    <Button active color='green' onClick={() => save()}>
                      {l.save}
                    </Button>
                  </Modal.Actions>

                    </Form>
                </Modal>





                  {/* TRIED SAVING WHILE NOT SIGNED IT */}
                  <Modal
                  basic
                  onClose={()=>{setTriedToSave(2)}}
                  open={triedToSave == 1}
                  size='mini'
                  >
                  <Header icon>
                    <Icon name='sign-in' />
                    {l.you_are_not_sigend_in}
                  </Header>
                  <Modal.Content>
                  <p>{l.create_account_to}</p>
                  </Modal.Content>
                  <Modal.Actions id="need_to_save_actions">
                    <Button color='green' inverted onClick={() => {setTriedToSave(2); window.open("users/sign_in", "_blank");}}>
                      {l.sign_in}
                    </Button>
                  </Modal.Actions>
                </Modal>

                {/* CUSTOM ERROR */}
                <Modal
                  centered
                  open={customErrorOpened}
                >
                  <Modal.Header>Maximum circuits number reached!</Modal.Header>
                  <Modal.Content>
                    <Modal.Description>
                      <p>You can't save more than the number of circuits you have saved so far, contact us to ask for remove limitation.</p>
                      <p>Or you can remove some circuits that you don't need to keep and try again.</p>

                    </Modal.Description>
                  </Modal.Content>
                  <Modal.Actions>
                    <Button onClick={() => setCustomError(false)}>OK</Button>
                  </Modal.Actions>
                </Modal>


                {/* RE-TRY SAVING ERROR */}
                <Confirm
                  open={isRetryOpened}
                  confirmButton={l.retry}
                  onCancel={()=>{setIsSaving(false), setRetryOpened(false)}}
                  content={isAnswering ? l.error_submit_answer : l.error_saving_circuit}
                  onConfirm={()=>{
                      //retry answer? or retry save?
                      if (isAnswering)
                          submitAnswer(true)
                      else
                        save()
                  }}
                  size='small'
                  />
              </Fragment>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </Grid.Column>
    </Grid>
    </>
    </PageVisibility>
    )

}

export default LabLayout
